import { BASE_TIPPY_DIRECTIONS as o, TIPPY_STICKY_VALUES as n } from "./tippy-utils.js";
const O = {
  none: void 0,
  small: "d-p4",
  medium: "d-p8",
  large: "d-p16"
}, P = {
  none: void 0,
  small: "d-pl4",
  medium: "d-pl8",
  large: "d-pl16"
}, _ = ["dialog", "menu", "listbox", "tree", "grid"], E = ["", "anchor"], t = ["none", "dialog", "first"], S = ["parent", "body", "root"], e = [
  ...n
], d = [
  ...o
], I = {
  POPOVER_PADDING_CLASSES: O,
  POPOVER_HEADER_FOOTER_PADDING_CLASSES: P,
  POPOVER_ROLES: _,
  POPOVER_CONTENT_WIDTHS: E,
  POPOVER_INITIAL_FOCUS_STRINGS: t,
  POPOVER_APPEND_TO_VALUES: S,
  POPOVER_STICKY_VALUES: e,
  POPOVER_DIRECTIONS: d
};
export {
  S as POPOVER_APPEND_TO_VALUES,
  E as POPOVER_CONTENT_WIDTHS,
  d as POPOVER_DIRECTIONS,
  P as POPOVER_HEADER_FOOTER_PADDING_CLASSES,
  t as POPOVER_INITIAL_FOCUS_STRINGS,
  O as POPOVER_PADDING_CLASSES,
  _ as POPOVER_ROLES,
  e as POPOVER_STICKY_VALUES,
  I as default
};
//# sourceMappingURL=popover-constants.js.map
